export const BLACK = '#000'
export const WHITE = '#fff'
export const LOGO_BLUE = '#00acf6'
export const LOGO_RED = '#ed0089'
export const LOGO_YELLOW = '#fef400'
export const BLUE = '#10cee4'
export const GREEN = '#4aba16'
